<form #intvlogForm="ngForm" (ngSubmit)="save(intvlogForm)">
  <div class="modal-header">
    <h4 class="modal-title">Intervention Log</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
  </div>
  <div class="modal-body d-flex flex-column" *ngIf="log">
    <div class="row mb-3">
      <label for="date" class="col-6" [ngClass]="{'required-field':edit}">Date Notified</label>
      <div class="col-6" *ngIf="!edit">
        {{ log.date | date: 'shortDate' }}
      </div>
      <div class="col-6" *ngIf="edit">
        <input #date="ngModel" [(ngModel)]="log.date" class="form-control" name="date" required type="date"
               [max]="maxDate">
        <div class="text-danger" *ngIf="date.touched && date.errors">
          <div *ngIf="date.errors['required']">Date is required</div>
          <div *ngIf="date.errors['max']">Date cannot be in the future</div>
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <label for="implementer" class="col-6" [ngClass]="{'required-field':edit}">Implementer</label>
      <span *ngIf="!edit" class="col-6">{{ log.implementer | staffId | async }}{{ log.legacy }}</span>
      <div class="col-6" *ngIf="edit">
        <select [(ngModel)]="log.implementer" class="form-select" name="implementer" required #implementer="ngModel">
          <option *ngFor="let s of staff" [ngValue]="s?.id">{{ s.displayName }}</option>
        </select>
        <ng-container *ngIf="implementer.touched && implementer.errors">
          <div class="text-danger">
            <div *ngIf="implementer.errors['required']">Implementer is required</div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="row mb-3">
      <label for="intervention" class="col-6" [ngClass]="{'required-field':edit}">Intervention</label>
      <span *ngIf="!edit" class="col-6">{{ log.intervention }}</span>
      <div class="col-6" *ngIf="edit">
        <select [(ngModel)]="log.intervention" class="form-select" name="intervention" required #intervention="ngModel">
          <option *ngFor="let i of interventions" [ngValue]="i.name">{{ i.name }}</option>
        </select>
        <ng-container *ngIf="intervention.touched && intervention.errors">
          <div class="text-danger">
            <div *ngIf="intervention.errors['required']">Intervention is required</div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="row mb-3">
      <label for="tier" class="col-6" [ngClass]="{'required-field':edit}">Intervention Tier</label>
      <span *ngIf="!edit" class="col-6">{{ log.tier }}</span>
      <div class="col-6" *ngIf="edit">
        <select [(ngModel)]="log.tier" class="form-select" name="tier" required #tier="ngModel">
          <option *ngFor="let t of tiers" [ngValue]="t.name">{{ t.name }}</option>
        </select>
        <ng-container *ngIf="tier.touched && tier.errors">
          <div class="text-danger">
            <div *ngIf="tier.errors['required']">Tier is required</div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="row">
      <div class="col-6 form-group mb-3">
        <label for="start" [ngClass]="{'required-field':edit}">Start</label>
        <input [(ngModel)]="log.start" class="form-control" name="start" required type="date" #start="ngModel" [disabled]="!edit">
        <ng-container *ngIf="start.touched && start.errors">
          <div class="text-danger">
            <div *ngIf="start.errors['required']">Start is required</div>
          </div>
        </ng-container>
      </div>
      <div class="col-6 form-group mb-3">
        <label for="end">End</label>
        <input [(ngModel)]="log.end" class="form-control" name="end" type="date" #end="ngModel" [disabled]="!edit">
        <ng-container *ngIf="end.touched && end.errors">
          <div class="text-danger">
            <div *ngIf="end.errors['required']">End is required</div>
          </div>
        </ng-container>
      </div>
      <div class="form-group mb-3">
        <label for="performance">Performance</label>
        <textarea [(ngModel)]="log.performance" class="form-control" name="performance" maxlength="5000"
                  #performance="ngModel" [disabled]="!edit"></textarea>
        <ng-container *ngIf="performance.touched && performance.errors">
          <div class="text-danger">
            <div *ngIf="performance.errors['maxlength']">Performance cannot exceed 5000 characters</div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-6 form-group">
        <label for="days_per_week" [ngClass]="{'required-field':edit}">Days Per Week</label>
        <input [(ngModel)]="log.days_per_week" class="form-control" name="days_per_week" required type="number" max="7"
               min="1" [disabled]="!edit">
        <ng-container
          *ngIf="intvlogForm.form.controls.days_per_week && intvlogForm.form.controls.days_per_week.touched && intvlogForm.form.controls.days_per_week.errors">
          <div class="text-danger" *ngIf="intvlogForm.form.controls.days_per_week.errors['required']">Days Per Week is
            required
          </div>
          <div class="text-danger" *ngIf="intvlogForm.form.controls.days_per_week.errors['max']">Days Per Week cannot be
            greater than 7
          </div>
          <div class="text-danger" *ngIf="intvlogForm.form.controls.days_per_week.errors['min']">Days Per Week cannot be
            less than 1
          </div>
        </ng-container>
      </div>
      <div class="col-6 form-group">
        <label for="min_per_day" [ngClass]="{'required-field':edit}">Minutes Per Day</label>
        <input [(ngModel)]="log.min_per_day" class="form-control" name="min_per_day" required type="number" min="1"
               pattern="[0-9]*" [disabled]="!edit">
        <ng-container
          *ngIf="intvlogForm.form.controls.min_per_day && intvlogForm.form.controls.min_per_day.touched && intvlogForm.form.controls.min_per_day.errors">
          <div class="text-danger" *ngIf="intvlogForm.form.controls.min_per_day.errors['pattern']">Minutes Per Day must
            be a number
          </div>
          <div class="text-danger" *ngIf="intvlogForm.form.controls.min_per_day.errors['required']">Minutes Per Day is
            required
          </div>
          <div class="text-danger" *ngIf="intvlogForm.form.controls.min_per_day.errors['min']">Minutes Per Day cannot be
            less than 1
          </div>
        </ng-container>
      </div>
    </div>
    <div class="form-group">
      <label for="other">Other</label>
      <textarea [disabled]="!edit" [(ngModel)]="log.other" class="form-control" name="other" maxlength="5000" #other="ngModel"></textarea>
      <ng-container *ngIf="other.touched && other.errors">
        <div class="invalid-feedback">
          <div *ngIf="other.errors['maxlength']">Other cannot exceed 5000 characters</div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="modal-footer">
    <button *ngIf="edit" (click)="save(intvlogForm)" type="button" class="btn btn-primary" [disabled]="intvlogForm.form.invalid">Save</button>
    <button *ngIf="!edit" type="button" class="btn btn-danger" (click)="edit = true">Edit</button>
    <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
  </div>
</form>
